import React from 'react';
import { IconProps } from './types';

const Heart: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  ignoreColor,
  size = 32,
  ...other
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    {...other}
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M12 21C11.734 21 11.48 20.895 11.292 20.706L3.52505 12.926C1.48905 10.886 1.48905 7.567 3.52505 5.527C4.50805 4.543 5.82105 4 7.22005 4C8.61905 4 9.93205 4.543 10.915 5.527L12 6.614L13.084 5.528C14.068 4.543 15.381 4 16.78 4C18.179 4 19.492 4.543 20.475 5.527C22.511 7.567 22.511 10.886 20.476 12.926L12.708 20.707C12.52 20.895 12.266 21 12 21Z"
    />
  </svg>
);

export default Heart;
